"use client";

import * as React from "react";
import { StatCard } from "@/components";
import { useTableData } from "@/hooks/use-liquidity";
import type { PoolTableRow } from "@/lib/dexscreener";

function formatUsd(value: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

function summarizeRows(rows: PoolTableRow[]) {
  let totalUsd = 0;
  let bidUsd = 0;
  let askUsd = 0;

  for (const row of rows) {
    totalUsd += row.liquidityUsd;
    askUsd += row.sideA.usd;
    bidUsd += row.sideB.usd;
  }

  return { totalUsd, bidUsd, askUsd };
}

export function TotalLiquidity() {
  const { data, isLoading, error } = useTableData();

  const summary = React.useMemo(() => {
    const rows = Array.isArray(data) ? data : [];
    return summarizeRows(rows);
  }, [data]);

  return (
    <>
      <StatCard
        label="Total Liquidity"
        value={error ? "—" : formatUsd(summary.totalUsd)}
        isLoading={isLoading}
      />
      <StatCard
        label="Bid Depth"
        value={error ? "—" : formatUsd(summary.bidUsd)}
        sublabel="Quote-side"
        isLoading={isLoading}
      />
      <StatCard
        label="Ask Depth"
        value={error ? "—" : formatUsd(summary.askUsd)}
        sublabel="Base-side"
        isLoading={isLoading}
      />
    </>
  );
}
